// extracted by mini-css-extract-plugin
module.exports = {"topLeaderboard":"azJOX6","placement":"z7l6_J","close":"V8xkq_"};